import React from "react";
import { CardContent, Divider, Grid } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { CardPageItem } from "../../custom/Page";
import DebouncedField from "./DebouncedField";
import LocaleNumberField from "./LocaleNumberField";

const HistoryWithdrawalFilters = ({ filters, onFilterChange, idFieldLabel = "app.search.withdrawal" }) => {
  return (
    <CardPageItem>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={3}>
            <DebouncedField
              id="withdrawId"
              name="withdrawId"
              label={<FormattedMessage id={idFieldLabel} />}
              value={filters.withdrawId}
              onDebouncedChange={onFilterChange}
              component={LocaleNumberField}
              checkEmptyError={false}
              decimalPlaces={0}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DebouncedField
              id="maxAmount"
              name="maxAmount"
              label="app.search.upTheAmount"
              value={filters.maxAmount}
              component={LocaleNumberField}
              checkEmptyError={false}
              onDebouncedChange={onFilterChange}
              decimalPlaces={2}
            />
          </Grid>

          <Grid item xs={12} sm={7} md={3}>
            <DebouncedField
              id="nameOrEmail"
              name="nameOrEmail"
              label={<FormattedMessage id="app.name" />}
              value={filters.nameOrEmail}
              onDebouncedChange={onFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={3}>
            <DebouncedField
              id="userId"
              name="userId"
              label={<FormattedMessage id="app.search.userId" />}
              value={filters.userId}
              onDebouncedChange={onFilterChange}
              component={LocaleNumberField}
              checkEmptyError={false}
              decimalPlaces={0}
            />
          </Grid>
        </Grid>
        <Divider style={{ marginTop: 4 }} />
      </CardContent>
    </CardPageItem>
  );
};

export default HistoryWithdrawalFilters;
